import { useEffect } from "react";
import HeaderLanding from "./HeaderLanding";
import { Outlet } from "react-router-dom";
import { safeFetch } from "@/api/safeFetch";
import { useProfesional } from "../context/ProfesionalContext";

const InnerLandingLayout = ({ className, defaultBg }: any) => {
  const { perfilId, landingData, setLandingData } = useProfesional();

  // cargar fuentes google
  useEffect(() => {
    const id = "google-fonts-landing";

    if (document.getElementById(id)) return;

    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css2?family=Inter&family=Poppins&family=Montserrat&family=Roboto&family=Open+Sans&family=Lato&family=Raleway&family=Nunito&family=DM+Sans&family=Work+Sans&family=Playfair+Display&family=Merriweather&family=Crimson+Text&family=Oswald&family=Bebas+Neue&family=Anton&family=Space+Grotesk&family=Manrope&family=Outfit&family=Plus+Jakarta+Sans&display=swap";

    document.head.appendChild(link);
  }, []);

  useEffect(() => {
    if (!perfilId) return;

    const load = async () => {
      try {
        const res = await safeFetch(`/api/landing/${perfilId}/theme`);

        if (!res.ok) return;

        const data = await res.json();

        if (!data?.theme) return;

        setLandingData((prev) => {
          if (!prev) return prev;

          return {
            ...prev,
            theme: {
              ...prev.theme,
              ...data.theme,
            },
          };
        });
      } catch (err) {
        console.error("LOAD LANDING ERROR:", err);
      }
    };

    load();
  }, [perfilId]);

  /**
   * ⛑ SAFE THEME (evita crashes)
   */
  const theme: any = landingData?.theme ?? {
    backgroundType: "image",
    backgroundColor: "#000",
    backgroundImage: defaultBg,
    globalStyles: {
      fontFamily: "Inter",
      textColor: "#fff",
      titleColor: "#fff",
    },
    components: {
      contact: {
        titleColor: "#fff",
        textColor: "#fff",
        fontFamily: "Inter",
      },
      hero: {
        titleColor: "#fff",
        textColor: "#fff",
        fontFamily: "Inter",
      },
      services: {
        titleColor: "#fff",
        textColor: "#fff",
        fontFamily: "Inter",
      },
    },
  };

  /**
   * 🎨 BACKGROUND LOGIC
   */
  const backgroundStyle = () => {
    if (theme?.backgroundType === "color") {
      return {
        backgroundColor: theme?.backgroundColor ?? "#000",
      };
    }

    return {
      backgroundImage: `url('${theme?.backgroundImage || defaultBg}')`,
    };
  };

  /**
   * 🧠 SAFE ACCESS (evita errores intermitentes)
   */
  const textColor = theme?.globalStyles?.textColor ?? "#fff";
  const fontFamily = theme?.globalStyles?.fontFamily ?? "Inter";

  return (
    <div
      className={`relative min-h-screen overflow-x-hidden ${className || ""}`}
      style={{
        color: textColor,
        fontFamily,
      }}
    >
      {/* BACKGROUND */}
      <div
        className="fixed inset-0 bg-center bg-no-repeat"
        style={{
          ...backgroundStyle(),
          backgroundSize:
            theme?.backgroundType === "image" ? "cover" : undefined,
        }}
      />

      <HeaderLanding data={landingData} />

      <main className="relative z-10 pt-24 px-4">
        <Outlet />
      </main>
    </div>
  );
};

export default InnerLandingLayout;
